import type { ComponentPropI } from "@Common/types/resources";
import { FormComponent } from "@Src/resources/forms/FormComponent";
import { Create } from "react-admin";

// Very important to provide empty default value
export const FormsCreate = (props: ComponentPropI) => {
	return (
		<Create disableAuthentication={props.isPublic} mutationMode="pessimistic">
			<FormComponent type="create" />
		</Create>
	);
};
